import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import { toUSDFormat } from "../../utils/utils";
import useStyles from "./GarageShipStyles";

import { useState } from "react";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import cashImg from "../../assets/imgs/exchange/money.png";
import logoImg from "../../assets/imgs/garage/cargo.png";
import config from "../../config/config";
import { CarShipPrice } from "../../constants/cars";
import { City, CONFIRMATION_DELAY } from "../../constants/const";
import { GarageActions } from "../../constants/enum/garage";
import { dispatchTxAction } from "../../helper/dispatchTxAction";
import useWallet from "../../hook/useWallet";
import {
  approveGameCashAction,
  carShipAction,
  getGarageListAction,
} from "../../reducers/game.slice";
import { CarInventoryType } from "../../types/CarInventoryType";
import CustomDropDown from "../CustomDropdown/CustomDropDown";
import useGameBankBalance from "../../hook/useGameBankBalance";
import { updateCashBalance } from "../../reducers/profile.slice";
import { getGameBankAllowance } from "../../helper/contractFunctions/MafiaGameBank";

interface GarageShipPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setActionType: (actionType: GarageActions | "") => void;
  targetItem: CarInventoryType | null;
}

const GarageShipPopup: React.FC<GarageShipPopupProps> = ({
  openModal,
  setOpenModal,
  setActionType,
  targetItem,
}) => {
  const { classes } = useStyles();
  const [city, setCity] = useState("");
  const { myProfile } = useAppSelector((state) => state.profile);
  const { account } = useWallet();
  const dispatch = useAppDispatch();
  const { signMsg, signature } = useAppSelector((state) => state.auth);
  const { updateBalance, balance } = useGameBankBalance(
    account,
    signMsg,
    signature
  );

  const handleClose = () => {
    setOpenModal(false);
    setActionType("");
  };

  const handleShipCar = async () => {
    if (
      !targetItem ||
      targetItem.id === undefined ||
      targetItem.city === undefined
    )
      return;

    if (!city) {
      toast.info("Select the destination city for your transfer.");
      return;
    }

    if (balance < CarShipPrice) {
      toast.info("Insufficient cash balance!");
      return;
    }

    const action = () => {
      dispatchTxAction(
        dispatch,
        carShipAction({
          itemId: targetItem?.id,
          account,
          cityId: City.findIndex((temp) => temp === city),
        }),
        () => {
          setOpenModal(false);
          updateBalance(account, signMsg, signature);
          dispatch(updateCashBalance(account));
          toast.success("Successfully shipped a car.");

          if (myProfile.city === undefined) return;
          dispatch(getGarageListAction({ account }));
        },
        CONFIRMATION_DELAY
      );
    };

    const allowance = await getGameBankAllowance(
      account,
      config.inventoryAddress
    );

    if (CarShipPrice > allowance) {
      dispatchTxAction(
        dispatch,
        approveGameCashAction({
          cashAmount: 10 ** 18,
          account,
          spender: config.inventoryAddress,
        }),
        () => {
          action();
        },
        CONFIRMATION_DELAY * 2
      );
    } else {
      action();
    }
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Ship car</Box>
          <Box>
            {targetItem?.carType.carName} - {targetItem?.car.damagePercent}%
            damage
          </Box>
          <Box
            component={"img"}
            src={`/assets/imgs/cars/${targetItem?.carType.image}.png`}
            className={classes.carImg}
          />
          <Box className={classes.location}>
            <Box>
              {myProfile &&
                myProfile.city !== undefined &&
                City[myProfile.city]}
            </Box>
            <Box>
              <ArrowRightAltIcon />
            </Box>
            <Box>
              <CustomDropDown
                items={City.filter((city, index) => index !== myProfile.city)}
                placeholder="Select"
                className={classes.citySelect}
                handleChange={(e) => {
                  setCity(e.target.value);
                }}
                value={city}
              />
            </Box>
          </Box>
          <Box className={classes.carDetail}>
            <Box component={"img"} src={cashImg} />
            <Box>{toUSDFormat(CarShipPrice)}</Box>
          </Box>
          <Box className={classes.buttonGroup}>
            <Button variant="contained" onClick={handleShipCar}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default GarageShipPopup;
